import React from 'react';
import { FaPencilAlt } from '@react-icons/all-files/fa/FaPencilAlt';
import { FaTrash } from '@react-icons/all-files/fa/FaTrash';
import DateFormat from '../../../commons/componentes/DateFormat';

export function proveedorIdFromRow(row: any): number | null {
  const id = row?.proveedor?.id ?? row?.proveedorId;
  if (id == null || id === '') return null;
  const n = Number(id);
  return Number.isFinite(n) ? n : null;
}

export function empresaIdFromProveedorRow(row: any): number | null {
  const id = row?.empresa?.id ?? row?.empresaId;
  if (id == null || id === '') return null;
  const n = Number(id);
  return Number.isFinite(n) ? n : null;
}

const GrupoProveedorTabla = (props: {
  proveedores: any[];
  onEditarProveedor?: (proveedor: any) => void;
  onEliminarProveedor?: (proveedor: any) => void;
}) => {
  const { proveedores, onEditarProveedor, onEliminarProveedor } = props;
  const showAcciones = onEditarProveedor != null || onEliminarProveedor != null;

  return (
    <div style={{ overflowX: 'auto', width: '100%' }}>
      <table className="table tabla-chica" style={{ minWidth: 300 }}>
        <thead>
          <tr className="bg-primary">
            <th>Proveedor</th>
            <th>Alias</th>
            <th>Alta</th>
            {showAcciones ? (
              <th className="text-center" style={{ width: 84 }} aria-label="Acciones">
                Acciones
              </th>
            ) : null}
          </tr>
        </thead>
        <tbody>
          {(proveedores ?? []).map((proveedor, index) => (
            <tr key={proveedor.id ?? index}>
              <td>{proveedor.proveedor?.nombre ?? '—'}</td>
              <td>{proveedor.alias ?? '—'}</td>
              <td>
                <DateFormat value={proveedor.fechaAlta} />
              </td>
              {showAcciones ? (
                <td className="text-center p-1 align-middle">
                  <div className="d-flex gap-1 justify-content-center flex-wrap">
                    {onEditarProveedor != null ? (
                      <button
                        type="button"
                        className="btn btn-sm btn-light d-inline-flex align-items-center justify-content-center"
                        style={{ width: 34, height: 30, padding: 0 }}
                        title="Editar proveedor"
                        aria-label="Editar proveedor"
                        onClick={() => onEditarProveedor(proveedor)}
                      >
                        <FaPencilAlt />
                      </button>
                    ) : null}
                    {onEliminarProveedor != null ? (
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-danger d-inline-flex align-items-center justify-content-center"
                        style={{ width: 34, height: 30, padding: 0 }}
                        title="Eliminar proveedor"
                        aria-label="Eliminar proveedor"
                        onClick={() => onEliminarProveedor(proveedor)}
                      >
                        <FaTrash />
                      </button>
                    ) : null}
                  </div>
                </td>
              ) : null}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default GrupoProveedorTabla;
